import types from 'redux/types';
import Queue from 'helpers/queue';
import { checkTypeValue } from 'helpers';
import {
  baseFilterResponder,
  baseLoadMore,
  baseSetDid,
  baseResponder,
  baseResponderTemplate,
  fetchFilterResponder,
  fetchFilterResponderFailed,
  fetchFilterResponderSuccess,
  fetchLoadMore,
  fetchLoadMoreFailed,
  fetchLoadMoreSuccess,
  fetchSetDID,
  fetchSetDIDFailed,
  fetchSetDIDSuccess,
  refetchResponderFailed,
  refetchResponderSuccess,
  switchStatus,
  switchStatusFailed,
  switchStatusSuccess,
  fetchListResponder,
  fetchListResponderFailed,
  fetchListResponderSuccess,
  fetchListResponderTemplate,
  fetchListResponderTemplateSuccess,
  fetchListResponderTemplateFailed,
  fetchSaveContent,
  fetchSaveContentSuccess,
  fetchSaveContentFailed,
  fetchDeleteContentSuccess,
  fetchDeleteContent,
  fetchDeleteContentFailed,
} from 'redux/handleReducers';
import { cloneDeep } from 'lodash';

const queue = new Queue();
const queueRemove = new Queue();
const queueAdding = new Queue();

const {
  REQUEST_GET_LIST_DIALOG,
  REQUEST_GET_LIST_DIALOG_SUCCESS,
  REQUEST_GET_LIST_DIALOG_FAILED,
  REQUEST_SWITCH_RESPONDER,
  REQUEST_SWITCH_RESPONDER_SUCCESS,
  REQUEST_SWITCH_RESPONDER_FAILED,
  REQUEST_DELETE_RESPONDER,
  REQUEST_DELETE_RESPONDER_SUCCESS,
  REQUEST_DELETE_RESPONDER_FAILED,
  REQUEST_ADD_RESPONDER,
  REQUEST_ADD_RESPONDER_SUCCESS,
  REQUEST_ADD_RESPONDER_FAILED,
  REQUEST_GET_RESPONDER_DETAIL,
  REQUEST_GET_RESPONDER_DETAIL_SUCCESS,
  REQUEST_GET_RESPONDER_DETAIL_FAILED,
  CLEAR_RESPONDER_DETAIL,
  REQUEST_SELECTED_NODE,
  CLEAR_SELECTED_NODE,
  REQUEST_SAVE_RESPONDER_CONTENT,
  REQUEST_SAVE_RESPONDER_CONTENT_SUCCESS,
  REQUEST_SAVE_RESPONDER_CONTENT_FAILED,
  REQUEST_DELETE_RESPONDER_CONTENT,
  REQUEST_DELETE_RESPONDER_CONTENT_SUCCESS,
  REQUEST_DELETE_RESPONDER_CONTENT_FAILED,
  REQUEST_UPLOAD_NODE,
  REQUEST_UPLOAD_NODE_FAILED,
  REQUEST_UPLOAD_NODE_SUCCESS,
  REQUEST_SAVE_DIALOG_SUCCESS,
  REQUEST_GET_LIST_DIALOG_TEMPLATE,
  REQUEST_GET_LIST_DIALOG_TEMPLATE_FAILED,
  REQUEST_GET_LIST_DIALOG_TEMPLATE_SUCCESS,
  REQUEST_SET_DID_GROUP_RESPONDER,
  REQUEST_SET_DID_GROUP_RESPONDER_FAILED,
  REQUEST_SET_DID_GROUP_RESPONDER_SUCCESS,
  REQUEST_LOAD_MORE_RESPONDER,
  REQUEST_LOAD_MORE_RESPONDER_SUCCESS,
  REQUEST_LOAD_MORE_RESPONDER_FAILED,
  REQUEST_FILTER_RESPONDER,
  REQUEST_FILTER_RESPONDER_SUCCESS,
  REQUEST_FILTER_RESPONDER_FAILED,
  REQUEST_REFETCH_RESPONDER_SUCCESS,
  REQUEST_REFETCH_RESPONDER_FAILED,
} = types;

const initialState = {
  isCreating: false,
  isFetchingDialogTemplate: false,
  isFetchingDialog: false,
  isFetchingDialogContent: false,
  isSavingDialog: false,
  isDeletingDialog: false,

  listDialog: [],
  listDialogTemplate: [],
  dialogDetail: {},
  selectedNode: {},

  queueResponder: queue.queue,
  queueRemove: queueRemove.queue,
  queueAdding: queueAdding.queue,

  errorAddResponder: null,
  errorDialogTemplate: null,
  ...baseResponder(),
  ...baseResponderTemplate(),
  ...baseSetDid(),
  ...baseLoadMore(),
  ...baseFilterResponder(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case REQUEST_REFETCH_RESPONDER_SUCCESS:
      return refetchResponderSuccess(actions, state);

    case REQUEST_REFETCH_RESPONDER_FAILED:
      return refetchResponderFailed(actions, state);

    case REQUEST_FILTER_RESPONDER:
      return fetchFilterResponder(actions, state);

    case REQUEST_FILTER_RESPONDER_SUCCESS:
      return fetchFilterResponderSuccess(actions, state);

    case REQUEST_FILTER_RESPONDER_FAILED:
      return fetchFilterResponderFailed(actions, state);

    case REQUEST_LOAD_MORE_RESPONDER:
      return fetchLoadMore(actions, state);

    case REQUEST_LOAD_MORE_RESPONDER_SUCCESS:
      return fetchLoadMoreSuccess(actions, state);

    case REQUEST_LOAD_MORE_RESPONDER_FAILED:
      return fetchLoadMoreFailed(actions, state);

    case REQUEST_SET_DID_GROUP_RESPONDER: {
      return fetchSetDID(actions, state);
    }
    case REQUEST_SET_DID_GROUP_RESPONDER_SUCCESS: {
      return fetchSetDIDSuccess(actions, state);
    }

    case REQUEST_SET_DID_GROUP_RESPONDER_FAILED: {
      return fetchSetDIDFailed(actions, state);
    }

    case REQUEST_ADD_RESPONDER: {
      queueAdding.pushToQueue(actions.contactGroupId);
      return {
        ...state,
        isCreating: true,
        queueAdding: queueAdding.queue,
      };
    }

    case REQUEST_ADD_RESPONDER_SUCCESS: {
      queueAdding.removeFromQueue(actions.contactGroupId);
      return {
        ...state,
        isCreating: false,
        errorAddResponder: null,
        queueAdding: queueAdding.queue,
      };
    }

    case REQUEST_ADD_RESPONDER_FAILED: {
      queueAdding.removeFromQueue(actions.contactGroupId);
      return {
        ...state,
        isCreating: false,
        errorAddResponder: actions.error,
        queueAdding: queueAdding.queue,
      };
    }

    case REQUEST_UPLOAD_NODE:
    case REQUEST_UPLOAD_NODE_SUCCESS:
      return {
        ...state,
      };

    case REQUEST_UPLOAD_NODE_FAILED:
      return {
        ...state,
        errorUploadNode: actions.error,
      };

    case REQUEST_DELETE_RESPONDER_CONTENT:
      return fetchDeleteContent(actions, state);

    case REQUEST_DELETE_RESPONDER_CONTENT_SUCCESS:
      return fetchDeleteContentSuccess(actions, state);

    case REQUEST_DELETE_RESPONDER_CONTENT_FAILED:
      return fetchDeleteContentFailed(actions, state);

    case REQUEST_SAVE_RESPONDER_CONTENT:
      return fetchSaveContent(actions, state);

    case REQUEST_SAVE_RESPONDER_CONTENT_SUCCESS:
      return fetchSaveContentSuccess(actions, state);

    case REQUEST_SAVE_RESPONDER_CONTENT_FAILED:
      return fetchSaveContentFailed(actions, state);

    case REQUEST_SAVE_DIALOG_SUCCESS:
      let tmp = Object.assign({}, state.dialogDetail);
      tmp = cloneDeep(actions?.dialogDetail || {});

      return {
        ...state,
        dialogDetail: {
          ...state.dialogDetail,
          ...tmp,
        },
      };

    case CLEAR_SELECTED_NODE: {
      return {
        ...state,
        selectedNode: {},
      };
    }

    case REQUEST_SELECTED_NODE: {
      return {
        ...state,
        selectedNode: actions.node,
      };
    }

    case REQUEST_GET_RESPONDER_DETAIL: {
      return {
        ...state,
        isFetchingDialogContent: true,
        errorDialogDetail: null,
      };
    }

    case REQUEST_GET_RESPONDER_DETAIL_SUCCESS: {
      return {
        ...state,
        isFetchingDialogContent: false,
        dialogDetail: actions.data,
      };
    }

    case REQUEST_GET_RESPONDER_DETAIL_FAILED: {
      return {
        ...state,
        isFetchingDialogContent: false,
        errorDialogDetail: actions.error,
      };
    }

    case CLEAR_RESPONDER_DETAIL: {
      return {
        ...state,
        isFetchingDialogContent: false,
        dialogDetail: {},
      };
    }

    case REQUEST_DELETE_RESPONDER: {
      queueRemove.pushToQueue(actions.id);
      return {
        ...state,
        queueRemove: queueRemove.queue,
      };
    }

    case REQUEST_DELETE_RESPONDER_SUCCESS: {
      queueRemove.removeFromQueue(actions.id);
      return {
        ...state,
        queueRemove: queueRemove.queue,
      };
    }

    case REQUEST_DELETE_RESPONDER_FAILED: {
      queueRemove.removeFromQueue(actions.id);
      return {
        ...state,
        queueRemove: queueRemove.queue,
      };
    }

    case REQUEST_SWITCH_RESPONDER: {
      return switchStatus(actions, state);
    }

    case REQUEST_SWITCH_RESPONDER_SUCCESS: {
      return switchStatusSuccess(actions, state);
    }

    case REQUEST_SWITCH_RESPONDER_FAILED: {
      return switchStatusFailed(actions, state);
    }

    case REQUEST_GET_LIST_DIALOG: {
      return fetchListResponder(actions, state);
    }

    case REQUEST_GET_LIST_DIALOG_SUCCESS: {
      return fetchListResponderSuccess(actions, state);
    }

    case REQUEST_GET_LIST_DIALOG_FAILED: {
      return fetchListResponderFailed(actions, state);
    }

    case REQUEST_GET_LIST_DIALOG_TEMPLATE: {
      return fetchListResponderTemplate(actions, state);
    }

    case REQUEST_GET_LIST_DIALOG_TEMPLATE_SUCCESS: {
      return fetchListResponderTemplateSuccess(actions, state);
    }

    case REQUEST_GET_LIST_DIALOG_TEMPLATE_FAILED: {
      return fetchListResponderTemplateFailed(actions, state);
    }

    default:
      return state;
  }
};
